import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ validationRules, validationUtils } = ssFormValidationUtils,
{ INPUT, DATE_PICKER, SELECT, CHECK, RADIO, generateLabelWithPopover } = ssFormUtils,
{ isRequiredOnCondition } = validationUtils,
{
    isRequired,
    isName,
    isPhone,
    isPast,
    isEmail,
    isFuture,
    isMinBirthDate,
    isMaxLength,
    isAlphanumeric,
    isLowercaseAlphanumeric,
    isMinLength
} = validationRules;

export const
linkedFormFields = [
    isRequiredOnCondition('expirationDate', 'passportType', f => f !== 'P_A')
],
personal = {
    title: 'Personal',
    key: 'candidatePersonal',
    step: 2,
    formItems: {
        firstName: {
            label: 'First/Given Name',
            type: INPUT,
            rules: [ isRequired, isName, isMaxLength(50) ]
        },
        middleName: {
            label: 'Middle Name',
            type: INPUT,
            rules: [ isName, isMaxLength(50) ],
            optional: true
        },
        lastName: {
            label: 'Last Name/Surname',
            type: INPUT,
            rules: [ isRequired, isName, isMaxLength(50) ]
        },
        nameSuffix: {
            label: 'Name Suffix',
            type: SELECT,
            rules: [  ],
            optional: true
        },
        dob: {
            label: 'Date of Birth',
            type: DATE_PICKER,
            rules: [ isRequired, isMinBirthDate ]
        },
        dobType: {
            label: 'Date of Birth Type',
            type: RADIO,
            rules: [ isRequired ]
        },
        phoneNumber: {
            label: 'Phone Number',
            type: INPUT,
            rules: [ isPhone ]
        }
    }
},
passport = {
    title: 'Passport',
    key: 'candidatePassport',
    step: 3,
    formItems: {
        passportType: {
            label: 'Passport Type',
            type: SELECT,
            rules: [],
            optional: true
        },
        passportNumber: {
            label: 'Passport Number',
            type: INPUT,
            rules: [ isRequired, isAlphanumeric ]
        },
        issueDate: {
            label: 'Issue Date',
            type: DATE_PICKER,
            rules: [ isRequired, isPast ]
        },
        expirationDate: {
            label: 'Expiration Date',
            type: DATE_PICKER,
            rules: [ isFuture ]
        },
        issuingCountry: {
            label: 'Issuing Country',
            type: SELECT,
            rules: [ isRequired ]
        },
        city: {
            label: 'City',
            type: INPUT,
            rules: [],
            optional: true
        }
    }
},
email = {
    title: 'ID & Email',
    key: 'candidateEmail',
    step: 4,
    formItems: {
        userId: {
            label: generateLabelWithPopover('User ID', 'Please create your User ID using only lowercase letters and/or numbers. Your User ID must be between 3 and 30 characters in length.'),
            type: INPUT,
            rules: [ isRequired, isLowercaseAlphanumeric, isMinLength(3), isMaxLength(30) ]
        },
        emailAddress: {
            label: generateLabelWithPopover('Email Address', 'Please use an email address that is valid, current, unique, and personal, to avoid loss of access that could result from your changing schools or employers, for example.'),
            type: INPUT,
            rules: [ isRequired, isEmail ]
        },
        verifyEmailAddress: {
            label: 'Verify Email Address',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
},
security = {
    title: 'Security',
    key: 'candidateSecurity',
    step: 5,
    formItems: {
        q1: {
            label: 'What city were you born in?',
            includeColon: false,
            type: INPUT,
            rules: [ isRequired ]
        },
        q2: {
            label: 'What is your favorite food?',
            includeColon: false,
            type: INPUT,
            rules: [ isRequired ]
        },
        q3: {
            label: 'What is your favorite color?',
            includeColon: false,
            type: INPUT,
            rules: [ isRequired ]
        }
    }
},
signature = {
    title: 'Signature',
    key: 'candidateSignature',
    step: 6,
    formItems: {
        agree: {
            label: 'I understand and agree to the above',
            type: CHECK,
            rules: [ isRequired ]
        },
        fullName: {
            label: 'Enter full name to digitally sign',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
};
